/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React,{useEffect, useState}from "react";
// react plugin used to create charts
import '../css/index.css'
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
// core components
import {
  dashboard24HoursPerformanceChart,
  dashboardEmailStatisticsChart,
  dashboardNASDAQChart,
} from "variables/charts.js";
import firebase from "../config/firebase";
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';


function Login(props,{navigation}) {
const [number,setnumber]=useState()
const [email,setemail]=useState()
const [name,setname]=useState()
const [password,setpassword]=useState()
const [error_email,seterror_email]=useState()
const [error_password,seterror_password]=useState()
const [error_phone,seterror_phone]=useState()
const [error_name,seterror_name]=useState()

const [error_email_sign,seterror_email_sign]=useState()
const [error_password_sign,seterror_password_sign]=useState()

const [email_sign,setemail_sign]=useState()
const [password_sign,setpassword_sign]=useState()




  useEffect(() => {
    return () => {
        // Anything in here is fired on component unmount.
        

    }
}, [])
  document.body.style.background = "linear-gradient(to bottom, #0f0c29, #302b63, #24243e)";
  document.body.style.margin = "0px";
  document.body.style.padding = "0px";
  document.body.style.display = "flex";
  document.body.style.justifyContent = "center";
  document.body.style.alignItems = "center";
  document.body.style.minHeight = "100vh";
  document.body.style.fontFamily = "'Jost', sans-serif";
  document.body.style.alignItems = "center";



const sign_up=()=>{
seterror_email()
seterror_password()
seterror_phone()
seterror_name()
document.getElementById('animation_show_ha').style.display='flex'
if (name) {
  seterror_name()
} else {
  seterror_name('*Required')
  document.getElementById('animation_show_ha').style.display='none'

}

if (email) {
  seterror_email()
} else {
  seterror_email('*Required')
    document.getElementById('animation_show_ha').style.display='none'

}
if (number) {
  seterror_phone()
} else {
  seterror_phone('*Required')
    document.getElementById('animation_show_ha').style.display='none'

}
if (password) {
  seterror_password()
} else {
  seterror_password('*Required')
    document.getElementById('animation_show_ha').style.display='none'

}




  if (name && number && email && password ) {
    
    
    
    
     firebase.auth().createUserWithEmailAndPassword(email, password)
    
     .then((userCredential) => {


        // Signed in 
        var user = userCredential.user;
        console.log("user>>>>>...",user);
     user.delete().then(function() {
        // console.log('deleted');

        var pass =JSON.stringify(password);

        // console.log("real varaible>>>>",baseString);
        var encodedString = window.btoa( pass ); // returns "bXktbmFtZS0x"
        console.log("encoded>>>",encodedString);



        sessionStorage.setItem('name',name)
        sessionStorage.setItem('email',email)
        sessionStorage.setItem('#4%f345^*-!23',encodedString)
        sessionStorage.setItem('otpNumber',number)

        props.history.push('/phone')
        document.getElementById('animation_show_ha').style.display='none'

        // User deleted.
      }).catch(function(error) {
        // An error happened.
        // console.log(' Not deleted');
});



})

.catch((error)=>{
  console.log('error>>>>',error.code.endsWith("password"));
  if (error.code.endsWith("password")) {
    seterror_password(error.message)
    document.getElementById('animation_show_ha').style.display='none'
  }
  else{
    seterror_email(error.message)
    document.getElementById('animation_show_ha').style.display='none'
  }

})
}

}
const sign_in=()=>{
  document.getElementById('animation_show_ha').style.display='flex'
seterror_email_sign()
seterror_password_sign()



  if (email_sign) {
    seterror_email_sign()
  } else {
    seterror_email_sign('*Required')
    document.getElementById('animation_show_ha').style.display='none'
  }
  if (password_sign) {
    seterror_password_sign()
  } else {
    seterror_password_sign('*Required')
    document.getElementById('animation_show_ha').style.display='none'

  }





  if (password_sign && email_sign) {
    

      
    firebase.auth().signInWithEmailAndPassword(email_sign,password_sign)
    .then((userCredential) => {

      console.log("user>>>>>>>",userCredential.user);

      try {
        
        firebase.firestore().collection("users").doc(userCredential.user.uid)
      .onSnapshot((doc) => {
        console.log("Current data: ", doc.data().name);
        
        if(doc.data().approved=='yes'){

          localStorage.setItem('admin_name',doc.data().name)
          localStorage.setItem('admin_number',doc.data().number)
          localStorage.setItem('admin_uid',userCredential.user.uid)
          
          document.getElementById('animation_show_ha').style.display='none'
          props.history.push('/admin/dashboard')
        }
        else{
          alert('Your Licence Is not Accepted')
          document.getElementById('animation_show_ha').style.display='none'
          // props.history.push('/login')

        }
      });
      }
       catch (error) {
        alert(error)
        document.getElementById('animation_show_ha').style.display='none'
      }
    })
    .catch((error)=>{
      console.log("error>>>>>>>>>>>>>>>>",error);
      if (error.code.endsWith("email")) {
        seterror_email_sign(error.message)
        document.getElementById('animation_show_ha').style.display='none'
      }
      else{
        seterror_password_sign(error.message)
        document.getElementById('animation_show_ha').style.display='none'
      }
    })


  }
   else {
    
  }




}



  return (
    <>
  

      {
      localStorage.getItem('admin_uid')?
      props.history.push('/admin/dashboard')
      :
  

   <div>
    <div  style={{display:'flex',justifyContent:'center',alignItems:'center',}}>
    <div id="animation_show_ha" style={{position:'absolute',backgroundColor:'rgb(23, 19, 54,0.8)',width:'100%',display:'none',justifyContent:'center',alignItems:'center',zIndex:'22',height:'100%',marginTop:'700px',}}>
      <CircularProgress size={62} />

      </div>

<h4 style={{color:'white',fontWeight:'bold',fontFamily:'monospace'}}>Hotel Admin panel</h4>
</div>
   <div className="main_ha">
     
  <input type="checkbox" id="chk" aria-hidden="true" />
  <div className="signup_ha">
      <label id='label_ha' htmlFor="chk" aria-hidden="true">
        Sign up
      </label>
    

      <div style={{marginTop:-40}}>
      <input id='input_ha' type="text" placeholder="User name" required  onChange={(e)=>setname(e.target.value)}   />
      <span style={{color:'#ED3449',display:'flex',margin: '-15px auto -0px   auto',width:'60%'}}>{error_name}</span>
      <input id='input_ha' type="email" placeholder="Email" required  onChange={(e)=>setemail(e.target.value)} />
      <span style={{color:'#ED3449',display:'flex',margin: '-15px auto -0px   auto',width:'60%'}}>{error_email}</span>
      <input id='input_ha' type="password" placeholder="Password" required  onChange={(e)=>setpassword(e.target.value)}  />
      <span style={{color:'#ED3449',display:'flex',margin: '-15px auto -0px   auto',width:'60%'}}>{error_password}</span>
      <input id='input_ha' type="Phone" onChange={(e)=>setnumber(e.target.value)}  placeholder="+923047267072" required />
      <span style={{color:'#ED3449',display:'flex',margin: '-15px auto -0px   auto',width:'60%'}}>{error_phone}</span>

      </div>
      <button id='button_ha' onClick={()=>{sign_up()}}   >Sign up</button>
      
  
  </div>
  <div className="login_ha">
    
      <label id='label_ha' htmlFor="chk" aria-hidden="true">
        Login
      </label>
      <input  id='input_ha' type="email" name="email" placeholder="Email" required="" onChange={(e)=>{setemail_sign(e.target.value)}} />
       <span style={{color:'#ED3449',display:'flex',margin: '-15px auto -0px   auto',width:'60%'}}>{error_email_sign}</span>
      <input id='input_ha'  type="password" name="pswd" placeholder="Password" required="" onChange={(e)=>{setpassword_sign(e.target.value)}} />
       <span style={{color:'#ED3449',display:'flex',margin: '-15px auto -0px   auto',width:'60%'}}>{error_password_sign}</span>
      <button id='button_ha' onClick={()=>{sign_in()}}    >Login</button>
  
  </div>
</div>
    </div>

  }
    </>
  );
}

export default Login;
